import LayoutHome from "../../components/Layout/Home";
import Footer from "../../components/Partials/Footer";
import HomeHeader from "../../components/Partials/HomeHeader";
import fotoPortadaText from "../../assets/img/fotos-portada-2.png";
import fotoPortadaMain from "../../assets/img/fotos-portada.png";
import { translate } from "../../assets/js/functions";
import  { Link }  from "react-router-dom";


export default function Home({ lang }) {



  return (
    <LayoutHome pageMeta={{}}>
      <div className="page-container py-5 is-flex is-flex-direction-column">

        <HomeHeader></HomeHeader>
        <main id="main" className="is-relative ">

          <div className="wrapper">
            <div className="columns is-desktop is-variable is-8">
              <div className="column flow--xl">
                <div className="flow">
                  <h1>{translate("Maestras y maestros represaliados")} <span className="has-text-primary">{translate("en Navarra")}</span></h1>
                  <h2>(1936-1976)</h2>
                </div>
                <p>
                  {translate("La Junta Superior de Educación, la nueva institución creada por la Diputación Foral de Navarra en agosto de 1936 para organizar y dirigir la enseñanza según los principios franquistas, tuvo como uno de sus principales objetivos prescindir del profesorado afín a los planteamientos político educativos republicanos. En consecuencia, desde ese mismo mes de agosto, puso en marcha un amplio proceso depurador.")}
                </p>
                <img loading="lazy" src={fotoPortadaText} alt="Instituto Navarro de la Memoria" width="807" height="392" />

              </div>
              <div className="column">
                <Link to="/buscador/">
                  <img loading="lazy" src={fotoPortadaMain} alt="Instituto Navarro de la Memoria" width="807" height="392" />
                </Link>
              </div>
            </div>
          </div>

        </main>
        <Footer></Footer>
      </div>

    </LayoutHome>
  );
}
